module.exports = __webpack_public_path__ + "static/img/min2.8385c76.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/agent/min2.png
// module id = O+jd
// module chunks = 1